module.exports = __webpack_public_path__ + "static/assets/7a6a5c794d6fe77611613ddfdf905506.png";